import view from "../../../../Enums";
import { makeStyle } from "../../../../utils";
import { rowCenter, h5, h6, subTitle1, subTitle2 } from "../../../../resources/styles";


const styles = {};


styles['container'] = makeStyle({
    height: '100%',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    background: 'linear-gradient(161deg, rgb(209, 20, 80), rgb(238, 63, 37) 95%, rgb(239, 65, 35))',
    paddingBottom: 24
}, { minWidth: 320, maxWidth: 320 }, { minWidth: 256 }, { width: '100%', maxWidth: 320 });


styles['heading'] = makeStyle({ color: 'white' }, { ...h5, padding: 36 }, { ...h6, padding: 24 }, view.TAB);


styles['section_heading'] = makeStyle({
    color: '#fffe', border: '1px solid white', borderRadius: '0 36px', marginBottom: 8,
}, { ...h6, padding: '12px 12px 12px 30px' }, { ...subTitle1, padding: '10px 10px 10px 19px' }, view.DESKTOP);


styles['content_heading_wrapper'] = makeStyle({ ...rowCenter, borderRadius: '0 24px' }, { padding: '8px 12px 8px 40px' }, { padding: '6px 8px 6px 30px' }, view.DESKTOP);

styles['dot'] = makeStyle({ width: 6, height: 6, borderRadius: 3, backgroundColor: '#fffd', marginRight: 12, marginTop: 2 });

styles['content_heading'] = makeStyle({ flex: 1, color: '#fffd' }, subTitle1, subTitle2, view.DESKTOP);


styles['menu_button'] = makeStyle({
    position: 'absolute', bottom: 32,
    borderRadius: '0 24px 24px 0'
});

styles['menu_icon'] = makeStyle({ color: 'white' });


export default styles;